/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import Navbar from 'components/layout/navbar/Navbar';
import Footer from 'components/layout/Footer';
import { useSelector } from 'react-redux';

const NewLayout = ({
  children,
  withNavbar,
  withFooter,
  navbarProps,
  footerProps,
}) => {
  const isWebView = useSelector(({ app }) => app?.isWebView);

  return (
    <div
      className="main-wrapper"
    >
      {withNavbar && !isWebView && <Navbar {...navbarProps} />}
      {children}
      {withFooter && !isWebView && <Footer {...footerProps} />}
    </div>
  );
};

NewLayout.defaultProps = {
  withNavbar: true,
  withFooter: true,
  withSidebar: false,
  navbarProps: null,
  footerProps: null,
  children: null,
};

NewLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func, PropTypes.object]),
  withNavbar: PropTypes.bool,
  withFooter: PropTypes.bool,
  withSidebar: PropTypes.bool,
  navbarProps: PropTypes.shape({ wrapperStyles: PropTypes.string }),
  footerProps: PropTypes.shape({ wrapperStyles: PropTypes.string }),
};
export default NewLayout;
